import React from 'react';
import { bindActionCreators } from 'redux';
import { connect } from 'react-redux';
import axios from 'axios';

class Notification extends React.Component {

    constructor() {
        super();
        this.state = {
            notifications: null
            // [{
            //     message: "message",
            //     background_color: "red",
            //     message_color: "blue"
            // },{
            //     message: "message2",
            //     background_color: "blue",
            //     message_color: "red"
            // }]
        };
    }
    componentDidMount() {
        // this.getNotifications()
    }
    componentDidUpdate(prevProps) {
        if (this.props.activeLot !== prevProps.activeLot) {
            this.getNotifications()
        }
    }
    getNotifications() {
        axios({
            method: 'GET',
            url: this.props.appProps.ruta + 'notifications?lottery_prefix=' + this.props.activeLot.prefix + "&" + this.props.sessionParam,
        }).then((response) => {
            if (response.data && response.data.length > 0) {
                this.setState({
                    notifications: [...response.data]
                })
            } else {
                this.setState({
                    notifications: null
                })
            }
        }).catch((err) => {
            this.setState({
                notifications: null
            })
            console.log(err)
        })
    }

    showNotifications() {
        const notifications = this.state.notifications.map(((el, i) => {
            return (
                <div className="con-random-numbers notification" style={{
                    backgroundColor: el.background_color,

                }} key={i + " " + el.message_color}>
                    <p className='notification' style={{
                        color: el.message_color,
                    }}>{el.message}</p>

                </div>
            )
        }))
        return notifications
    }

    render() {
        if (this.state.notifications) {
            return (
                this.showNotifications()
            )
        } else { return null }
    }
}


function mapStateToProps(state) {
    return {
        activeLot: state.activeLot,
        appProps: state.appProps,
        serverTime: state.serverTime,
        sessionParam: state.sessionParam
    }
}
function matchDispatchToProps(dispatch) {
    return bindActionCreators({

    }, dispatch)
}
export default connect(mapStateToProps, matchDispatchToProps)(Notification);